import { IconeTemaClaro, IconeTemaEscuro } from '../icones'
import { MarcaRescueLab } from './MarcaRescueLab'
import { NavegacaoModulos } from './NavegacaoModulos'
import { Sobre } from './Sobre'
import type { IdModulo } from './modulos'
import type { ModoLayout } from './useModoLayout'

export type Tema = 'claro' | 'escuro'

interface Props {
  moduloAtual: IdModulo
  aoTrocarModulo: (id: IdModulo) => void
  tema: Tema
  aoAlternarTema: () => void
  modoLayout: ModoLayout
}

/**
 * Barra superior única e persistente: marca, navegação dos módulos e tema.
 *
 * É a mesma nos seis módulos. O logo horizontal vira só o ícone abaixo de
 * 600 px por regra de CSS — é a informação menos acionável da barra, e a
 * navegação tem prioridade sobre ela quando o espaço acaba.
 *
 * À direita do alternador de tema fica o botão Sobre — o primeiro a ocupar o
 * espaço que antes ficava vazio de propósito ("botão que não faz nada é
 * ruído"). Outras configurações futuras entram do mesmo lado.
 */
export function BarraAplicacao({
  moduloAtual,
  aoTrocarModulo,
  tema,
  aoAlternarTema,
  modoLayout,
}: Props) {
  const rotuloTema = tema === 'claro' ? 'Usar modo escuro' : 'Usar modo claro'

  return (
    <header className="barra-menu" aria-label="Menu principal">
      <div className="marca-horizontal">
        <MarcaRescueLab variante="horizontal" className="marca-horizontal__completa" />
        <MarcaRescueLab variante="icon" className="marca-horizontal__icone" />
      </div>

      <span className="barra-menu__divisor" aria-hidden="true" />

      <NavegacaoModulos
        moduloAtual={moduloAtual}
        aoTrocar={aoTrocarModulo}
        modoLayout={modoLayout}
      />

      <span className="barra-menu__divisor" aria-hidden="true" />

      <button
        type="button"
        className="alternar-tema tema-no-topo"
        onClick={aoAlternarTema}
        aria-label={rotuloTema}
        aria-pressed={tema === 'escuro'}
        title={rotuloTema}
      >
        {tema === 'escuro' ? <IconeTemaEscuro tamanho={18} /> : <IconeTemaClaro tamanho={18} />}
      </button>

      <Sobre />
    </header>
  )
}
